/* eslint-disable no-restricted-syntax */
import React from 'react';
import {
  usePlateEditorRef,
  useEventPlateId,
  getNodeEntries,
  removeMark,
  unsetNodes,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ToolbarButton } from './ToolbarButton';

const CLEARABLE_MARKS = [
  'fontFamily',
  'fontSize',
  'color',
  'bold',
  'strikethrough',
  'italic',
  'underline',
  'backgroundColor',
];

export const ClearFormatButton = ({ ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId());
  return (
    <ToolbarButton
      name="Clear formatting"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        // Get generator function for nodes in selection.
        // getMarks method doesn't include all selected text.
        const nodes = getNodeEntries(editor) ?? {};
        if (nodes) {
          for (const nodeEntry of nodes) {
            // nodeEntry has the node in 0 index
            // and location in 1 index. This should
            // always be true.
            const node = nodeEntry[0];

            // Need to clear alignment and indentation.
            const path = nodeEntry[1];
            if (node.align || node.indent) {
              unsetNodes(editor, ['align', 'indent'], { at: path });
            }

            // We know this is a leaf if it has text attr.
            if (node.text) {
              const marks = [];
              CLEARABLE_MARKS.forEach((mark) => {
                if (node[mark]) {
                  marks.push(mark);
                }
              });
              if (marks.length > 0) {
                removeMark(editor, { key: marks });
              }
            }
          }
        }
      }}
      icon={<FontAwesomeIcon icon={['fa', 'remove-format']} />}
      {...props}
    />
  );
};
